import React from 'react'
import TextInput from '../components/Input/TextInput'
import PrimaryButton from '../components/Button/PrimaryButton'
import moment from 'moment-timezone'
import Select from '../components/Input/Select'
import FormSection from '../components/Card/FormSection'
import { LIGA_SATU_CLUB, MATCH_STATUS_DUMMY } from '../constants/dummy'

const PertandinganForm = ({ onSubmit, data, isLoading }) => {
  return (
    <form onSubmit={onSubmit} encType="multipart/form-data">
      <div className="flex flex-col gap-3 p-3 lg:pl-0">
        <FormSection
          title="Informasi"
          description="Masukkan info pertandingan untuk ditampilkan pada Homepage"
        >
          <TextInput
            label="Pertandingan"
            placeholder="Masukkan judul pertandingan, mis:Liga 1 2022/2023"
            type="text"
            name="matchTitle"
            required={true}
            defaultValue={data?.attributes?.matchTitle}
          />
          <div className="grid gap-4 sm:grid-cols-2 max-w-[520px]">
            <TextInput
              label="Tanggal Pertandingan"
              type="date"
              name="date-tanggal"
              required={true}
              defaultValue={
                data?.attributes?.date
                  ? moment(data?.attributes?.date)
                      .tz('Asia/Jakarta')
                      .format('YYYY-MM-DD')
                  : null
              }
            />
            <TextInput
              label="Jam Pertandingan"
              type="time"
              name="date-jam"
              required={true}
              defaultValue={
                data?.attributes?.date
                  ? moment(data?.attributes?.date)
                      .tz('Asia/Jakarta')
                      .format('HH:mm')
                  : null
              }
            />
          </div>
          <div className="max-w-[320px]">
            <Select
              label="Status Pertandingan"
              placeholder="Pilih Status pertandingan"
              name="matchStatus"
              required={true}
              options={MATCH_STATUS_DUMMY.map((l) => ({ label: l, value: l }))}
              defaultValue={data?.attributes?.matchStatus}
            />
          </div>
        </FormSection>

        <FormSection
          title="Tim Tuan Rumah"
          description="Tambahkan informasi mengenai tim tuan rumah"
        >
          <div className="grid gap-4 sm:grid-cols-2 max-w-[520px]">
            <Select
              label="Tim Tuan Rumah"
              placeholder="Pilih tim tuan rumah"
              name="teamLeftName"
              required={true}
              options={LIGA_SATU_CLUB.map((l) => ({
                label: l.name,
                value: l.name,
              }))}
              defaultValue={data?.attributes?.teamLeftName}
            />
            <TextInput
              label="Skor Tim Tuan Rumah"
              placeholder="Masukkan skor"
              type="number"
              name="teamLeftScore"
              required={true}
              defaultValue={data?.attributes?.teamLeftScore}
            />
          </div>
        </FormSection>

        <FormSection
          title="Tim Tamu"
          description="Tambahkan informasi mengenai tim tamu"
        >
          <div className="grid gap-4 sm:grid-cols-2 max-w-[520px]">
            <Select
              label="Tim Tamu"
              placeholder="Pilih tim tamu"
              name="teamRightName"
              required={true}
              options={LIGA_SATU_CLUB.map((l) => ({
                label: l.name,
                value: l.name,
              }))}
              defaultValue={data?.attributes?.teamRightName}
            />
            <TextInput
              label="Skor Tim Tamu"
              placeholder="Masukkan skor"
              type="number"
              name="teamRightScore"
              required={true}
              defaultValue={data?.attributes?.teamRightScore}
            />
          </div>
        </FormSection>

        <div className="flex justify-end rounded-card border border-line bg-white shadow-card px-5 py-4">
          <PrimaryButton type="submit" loading={isLoading}>
            Simpan
          </PrimaryButton>
        </div>
      </div>
    </form>
  )
}

export default PertandinganForm
